export type FormType =
  | "newsletter"
  | "contact"
  | "enquiry"
  | "competition"
  | "application"
  | "other";

export type LinkType = "internal" | "outbound" | "email" | "phone" | "download";

export type FormSubmitEvent = {
  event: "form_submit";
  form_id: string;
  form_name?: string;
  form_type: FormType;
  enquiry_type?: string;
};

export type CtaClickEvent = {
  event: "cta_click";
  label: string;
  link_url: string;
  link_type: LinkType;
  location?: string;
};

export type OutboundLinkType =
  | "tenant"
  | "reservation"
  | "hotel_book"
  | "ticket"
  | "event_ticket"
  | "gift_card";

export type LeadType = "leasing" | "newsletter";

export type OutboundClickEvent = {
  event: "outbound_click";
  link_type: OutboundLinkType;
  link_url: string;
  label?: string;
  item_id?: string;
  item_name?: string;
  value?: number;
};

export type GenerateLeadEvent = {
  event: "generate_lead";
  lead_type: LeadType;
  form_id?: string;
  value?: number;
};

export type GetDirectionsEvent = {
  event: "get_directions";
  item_id?: string;
  item_name?: string;
  location_zone?: string;
};

export type ViewItemEvent = {
  event: "view_item";
  item_id: string;
  item_name?: string;
  item_category?: string;
  value?: number;
};

export type SearchEvent = {
  event: "search";
  search_term: string;
  results_count?: number;
};

export type AddToWishlistEvent = {
  event: "add_to_wishlist";
  item_id: string;
  item_name?: string;
  item_category?: string;
};

export type PageViewEvent = {
  event: "page_view";
  page_path: string;
  page_location: string;
  page_title: string;
};

export type PopupDismissMethod = "close" | "backdrop_or_escape";

export type PopupViewEvent = {
  event: "popup_view";
  popup_id: string;
  popup_name?: string;
  popup_variant?: string;
  page_path: string;
};

export type PopupClickEvent = {
  event: "popup_click";
  popup_id: string;
  popup_name?: string;
  /** `cta` for the call-to-action, otherwise how it was dismissed. */
  popup_action: "cta" | PopupDismissMethod;
  link_url?: string;
  page_path: string;
};

export type AnalyticsEvent =
  | FormSubmitEvent
  | CtaClickEvent
  | OutboundClickEvent
  | GenerateLeadEvent
  | GetDirectionsEvent
  | ViewItemEvent
  | SearchEvent
  | AddToWishlistEvent
  | PageViewEvent
  | PopupViewEvent
  | PopupClickEvent;

type DataLayerWindow = Window & { dataLayer?: unknown[] };

export function pushEvent(event: AnalyticsEvent): void {
  if (typeof window === "undefined") {
    return;
  }

  const target = window as DataLayerWindow;
  target.dataLayer = target.dataLayer ?? [];
  target.dataLayer.push(event);
}
